import React from "react";

export default function PresetListHeader(props) {

  return (
    <li className="fk-table__item fk-table__item--heading">
      <div className="fk-table__item-name fk-table__item-name--first fk-table__item--w-sm">
        Comando
      </div>
      <div className="fk-table__item-name fk-table__item-name--second fk-table__item--w-md">
        Mensagem
      </div>
      <div className="fk-table__item-name fk-table__item-name--lastone"></div>
      <div className="fk-table__item-name fk-table__item-name--lastone"></div>
    </li>
  );
}